import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { CardModule } from "src/app/common/components/card/card.module";
import { ColoredBadgeModule } from "src/app/common/components/colored-badge/colored-badge.module";
import { ContentfulActionField } from "src/app/core/interfaces/contentful";
import { ButtonComponent } from "src/app/shared/ui/button/button.component";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";
import { CommunalPlatformNewsEntry } from "../../news/news.interfaces";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "tpm-contentful-list-item",
  templateUrl: "./contentful-list-item.component.html",
  styleUrls: ["./contentful-list-item.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    ColoredBadgeModule,
    EneButtonModule,
    CardModule,
    ButtonComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentfulListItemComponent {
  @Input() public isMobileView: boolean;
  @Input() public data: CommunalPlatformNewsEntry;

  @Output() public readonly listItemClick = new EventEmitter<ContentfulActionField>();

  public readonly trackByIndex = (index: number): number => index;
}
